import React from 'react'
import Layout from '../../../components/common/pageLayout'
import Form from '../../../components/MasterData/SubContractor/add'
import constant from '../../../constant'
import { toast } from 'react-toastify'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import { v3_edit_sub_contractor } from '../../../actions/v3/masterData'
const Add = (props) => {

    const location = useLocation();
    const { data, page } = location.state || {};
    const onSubmit = (model) => {
        model.previousName = JSON.parse(atob(data))['NAME']
        v3_edit_sub_contractor(model).then((res) => {
            if (res.status) {
                toast.success(res.result.message)
                props.history.push(constant.Authedcomponent.listSubContractorMasterData.url, {
                    page: page // Replace 'yourData' with the data you want to pass
                });
            }
            else {
                toast.error(res.error)
            }
        })
    }
    return (
        <React.Fragment>
            <Layout
                title={'Edit Sub Contractor'}>
                <Form
                    title={'Edit Sub Contractor'}
                    onSubmit={onSubmit}
                    data={JSON.parse(atob(data))}
                    buttonName={'Save Sub Contractor'}

                />
            </Layout>

        </React.Fragment>
    )
}

export default Add